import {
  RaiseComplaintByTxnRefIdRequest,
  ApiEnvelope,
  RaiseComplaintResponsePayload,
  ComplaintStatusRequest,
  ComplaintStatusResponsePayload,
  DispositionApiPayload,
  TransactionStatusRequest,
  TransactionStatusResponsePayload,
} from "store/bbps/Complaint/bbpsComplaintTypes";
import userHttp from "../../axios.services/instances/userHttp";

// If you already have `api` instance in project, use that instead.
// const http: AxiosInstance = axios.create({
//   baseURL: "", // keep empty if same domain; else set env base URL
//   withCredentials: true, // if your auth uses cookies
// });

export const bbpsComplaintService = {
  // Unified API - accepts both orderId OR txnReferenceId
  async raiseComplaint(payload: any) {
    const res = await userHttp.post<ApiEnvelope<RaiseComplaintResponsePayload>>(
      "/api/v1/bbps/complaint/raise",
      payload,
    );

    return res;
  },

  // @deprecated - Use raiseComplaint() instead (kept for backward compatibility)
  async raiseComplaintByTxnRefId(payload: RaiseComplaintByTxnRefIdRequest) {
    const res = await userHttp.post<ApiEnvelope<RaiseComplaintResponsePayload>>(
      "/api/v1/bbps/complaint/raiseByTxnRefId",
      payload,
    );

    return res;
  },

  async complaintStatus(payload: ComplaintStatusRequest) {
    const res = await userHttp.post<
      ApiEnvelope<ComplaintStatusResponsePayload>
    >("/api/v1/bbps/complaint/status", payload);

    // console.log("service: ", res);

    return res;
  },

  async getDispositions() {
    const res = await userHttp.get<ApiEnvelope<DispositionApiPayload>>(
      "/api/v1/bbps/complaint/disposition",
    );

    // console.log("service: ", res);

    return res;
  },

  async transactionStatus(payload: TransactionStatusRequest) {
    const res = await userHttp.post<
      ApiEnvelope<TransactionStatusResponsePayload>
    >("/api/v1/bbps/complaint/transaction-status", payload);

    return res;
  },

  async searchRaise(params: any) {
    const res = await userHttp.get("/api/v1/bbps/complaint/transaction/search-raise", {
      params,
    });
    return res;
  },

  async searchStatus(params: any) {
    const res = await userHttp.get("/api/v1/bbps/complaint/transaction/search-status", {
      params,
    });
    return res;
  },
};
